import gql from 'graphql-tag';

import { chatClient } from 'src/config/Apollo';
import { getCurrentUser, getPartners } from 'src/selectors/userSelectors';

import { RootState } from '../config/Store';
import { Member } from '../models/Common';

const getPartnersQuery = gql`
  query getPartnersQuery {
    partners {
      uuid
      firstName
      lastName
      email
      localTimezone
      conversationUuid
      memberAssignments {
        uuid
        active
        createdAt
        coach {
          uuid
        }
      }
    }
  }
`;

interface PartnersState {
  partners: Member[];
  fetching: boolean;
}

const defaultState: PartnersState = {
  partners: [],
  fetching: false,
};

export const partners = {
  state: defaultState,
  reducers: {
    setFetching: (currentState: PartnersState, payload: boolean) => {
      return { ...currentState, fetching: payload };
    },
    setPartners: (currentState: PartnersState, newPartners: Member[]) => {
      return { partners: newPartners, fetching: false };
    },
  },
  effects: (dispatch: any) => ({
    // to be removed when we add subscription for partners
    fetchPartnersIfMissing(uuid: string, rootState: RootState): void {
      const user = getCurrentUser(rootState);

      if (user.uuid === uuid || rootState.partners.fetching) {
        return;
      }

      const data = getPartners(rootState);
      const exists = data.find((partner) => partner.uuid === uuid);

      if (!exists) {
        dispatch.partners.fetchPartners();
      }
    },
    async fetchPartners(): Promise<void> {
      dispatch.partners.setFetching(true);

      const response = await chatClient.query({
        query: getPartnersQuery,
        fetchPolicy: 'network-only',
      });

      dispatch.partners.setFetching(false);

      const partnerData: Member[] = response.data.partners;

      const newPartners = partnerData.map((partner: Member) => {
        // removed memberAssignments redundant code

        return {
          ...partner,
        };
      });

      dispatch.partners.setPartners(newPartners);
    },
  }),
};
